var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCustomTabIcon = function SvgCustomTabIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18429 15.5L3.88826 13.2136L1.4273 12.6491L1.66751 9.99716L0 8L1.66751 6.00284L1.4273 3.35092L3.88826 2.78643L5.18429 0.5L7.5 1.52918L9.81571 0.5L11.1117 2.78643L13.5727 3.35092L13.3325 6.00284L15 8L13.3325 9.99716L13.5727 12.6491L11.1117 13.2136L9.81571 15.5L7.5 14.4708L5.18429 15.5ZM5.64801 14.0439L7.5 13.2223L9.37432 14.0439L10.4051 12.2194L12.4023 11.7398L12.2207 9.59651L13.5643 8L12.2207 6.38011L12.4023 4.23679L10.4051 3.78064L9.35199 1.95606L7.5 2.77769L5.62568 1.95606L4.59492 3.78064L2.59768 4.23679L2.77925 6.38011L1.43565 8L2.77925 9.59651L2.59768 11.7632L4.59492 12.2194L5.64801 14.0439ZM6.73742 10.4356L10.5894 6.40349L9.82406 5.579L6.73742 8.81004L5.17594 7.19889L4.41063 8L6.73742 10.4356Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomTabIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/custom-tab-icon.1927a59b.svg";
export { ForwardRef as ReactComponent };